import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import { useLazyQuery } from '@apollo/client';
import { SEARCH_CITIES } from '../mutations/address'; // Certifique-se de criar esta consulta em um arquivo apropriado
import useDebounce from '../hooks/useDebounce'; // Importar o hook de debounce

const AddressForm = ({ initialValues = {}, cities = [], onSearchCity }) => {
  const [searchCities, { data: citiesData }] = useLazyQuery(SEARCH_CITIES, {
    fetchPolicy: 'network-only'
  });
  const [localCities, setLocalCities] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 1000); // 1000ms delay

  useEffect(() => {
    if (debouncedSearchTerm.length > 2) {
      searchCities({ variables: { query: debouncedSearchTerm } });
    }
  }, [debouncedSearchTerm, searchCities]);

  useEffect(() => {
    if (citiesData) {
      setLocalCities(citiesData.searchCities);
    }
  }, [citiesData]);

  useEffect(() => {
    if (initialValues.city) {
      setLocalCities([{ id: initialValues.city.id, name: initialValues.city.name, state: initialValues.city.state }]);
    }
  }, [initialValues]);

  const handleSearchCity = (value) => {
    setSearchTerm(value);
    if (onSearchCity) {
      onSearchCity(value);
    }
  };

  // Use cities from props if available, otherwise use local cities
  const cityOptions = cities.length > 0 ? cities : localCities;

  return (
    <>
      <Row gutter={16}>
        <Col span={3}>
          <Form.Item name={["address", "zipcode"]} label="CEP" rules={[{ required: true, message: 'Por favor, insira o CEP' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name={["address", "cityId"]} label="Cidade" rules={[{ required: true, message: 'Por favor, selecione a cidade' }]}>
            <Select
              showSearch
              placeholder="Pesquisar cidade"
              onSearch={handleSearchCity}
              filterOption={false}
              options={cityOptions.map(city => ({ value: city.id, label: `${city.name} - ${city?.state?.initials}` }))}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={["address", "description"]} label="Descrição">
            <Input />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name={["address", "district"]} label="Bairro" rules={[{ required: true, message: 'Por favor, insira o bairro' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name={["address", "street"]} label="Rua" rules={[{ required: true, message: 'Por favor, insira a rua' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name={["address", "number"]} label="Número" rules={[{ required: true, message: 'Por favor, insira o número' }]}>
            <Input />
          </Form.Item>
        </Col>

      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item name={["address", "complement"]} label="Complemento">
            <Input.TextArea allowClear={true} />
          </Form.Item>
        </Col>
      </Row>

    </>
  );
};

export default AddressForm;